import React, { useMemo } from 'react';
import { useRouter } from 'next/router';

import RecitersListItem from './item/index';
import RecitersListFilterBtn from './filter-btn/index';
import { Reciter } from '@/infrastructure/class/reciter';
import { IReciter } from '@/infrastructure/interfaces/i-reciter';
import s from './styles.module.scss';

interface IRecitersListProps {
  items: IReciter[];
  className?: string;
}

const RecitersList: React.FC<IRecitersListProps> = (props) => {
  const { items, className = '' } = props;

  const router = useRouter();
  const { locale } = router;

  const reciters = useMemo<Reciter[]>(
    () => items.map((reciter) => new Reciter(reciter, locale)),
    [items, locale]
  );

  return (
    <div className={className}>
      <div className={s['toolbar']}>
        <RecitersListFilterBtn />
      </div>
      <ul className={s['list']}>
        {reciters.map((reciter, index) => (
          <li className={s['list-item']} key={index}>
            <RecitersListItem data={reciter} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecitersList;
